= <template>
    <div class="ValueForm">
        <div class="flex row-left-center mb-2">
            <div class="flex-1">
                <WText
                    tag="label"
                    typo="label"
                    :size="14"
                >
                    {{ $t('entities.dicts.value.value.label') }}
                </WText>
                <WFieldError
                    :validator="$v.value"
                    :label="$t('entities.dicts.value.value.label')"
                    #default="{ errorMessage, listeners }"
                >
                    <WInput
                        v-model="value"
                        :error="errorMessage"
                        :placeholder="$t('entities.dicts.value.value.placeholder')"
                        :disabled="isLoading"
                        name="alias"
                        type="text"
                        v-on="listeners"
                    />
                </WFieldError>
            </div>
        </div>

        <div class="flex row-right-center">
            <WButton
                outline
                color="accent-blue"
                :loading="isLoading"
                @click="$emit('onReset')"
            >
                {{ $t('entities.creation.reset') }}
            </WButton>
            <WButton
                color="primary"
                :loading="isLoading"
                :disabled="isLoading"
                class="ml-2"
                @click="handleSubmit"
            >
                {{ $t('entities.dicts.create.submit') }}
            </WButton>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { Api, apiRequest } from '@/api'

export default {
    name: 'ValueForm',
    mixins: [validationMixin],
    props: {
        dictKey: VueTypes.oneOfType([Number, String]).isRequired,
        fieldType: VueTypes.string.def('values'),
    },
    data () {
        return {
            value: '',
            isLoading: false,
        }
    },
    validations () {
        return {
            value: { required },
        }
    },
    methods: {
        async handleSubmit () {
            this.$v.$touch()

            if (!this.$v.$invalid) {
                this.isLoading = true
                const params = { dictKey: this.dictKey, fieldType: this.fieldType, params: { label: this.value } }
                apiRequest(Api().dictionaries.fieldCreate(params))
                    .then(() => this.$emit('onSubmit', params))
                    .catch(() => this.$emit('onError'))
                    .finally(() => (this.isLoading = false))
            }
        },
    },
}
</script>
